import type { GraphicsSearchResults } from '@components/pages/Graphics/SearchPage/interfaces';
import { api_react_v1_graphics_search_path } from '@routes';

import request from './request';

export interface GetGraphicsSearchResultsResponse {
  currentPage: number;
  pageCount: number;
  searchResults: GraphicsSearchResults[];
}

export const GRAPHICS_SEARCH_RESULTS_KEY = 'GRAPHICS_SEARCH_RESULTS';

export async function getGraphicsSearchResults({
  limit,
  page,
  query,
}: {
  limit: number;
  page: number;
  query: string;
}): Promise<GetGraphicsSearchResultsResponse> {
  const response = await request('post', api_react_v1_graphics_search_path(), {
    limit,
    page,
    query,
  });

  if (response.success) {
    return {
      currentPage: response.data.current_page,
      pageCount: response.data.page_count,
      searchResults: response.data.search_results,
    };
  } else {
    throw new Error(response.error);
  }
}
